import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="bg-white/5 border border-white/10 rounded-xl mb-3 overflow-hidden transition-colors hover:bg-white/[0.07]" data-id="element-18">
      <button className="w-full py-5 px-6 flex justify-between items-center text-left focus:outline-none" onClick={onClick} data-id="element-19">
        <h4 className="text-lg font-semibold text-white pr-8" data-id="element-20">{question}</h4>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="flex-shrink-0 text-amber" data-id="element-21">
          <ChevronDown className="w-5 h-5" data-id="element-22" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-23">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-24">
            <div className="px-6 pb-6 pt-2" data-id="element-25">
              <p className="text-body leading-relaxed" data-id="element-26">{answer}</p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: 'Is this a raw food diet?',
    a: 'No. We show you how to "hack" your current kibble using affordable "Living Toppers" from any grocery store.'
  }, {
    q: 'My dog is already a senior. Is it too late?',
    a: 'Never. Biology is plastic. Most owners see a "Puppy-like" energy boost in senior dogs within the first 21 days.'
  }, {
    q: 'Is this a physical book?',
    a: 'No. This is a Digital Protocol. You get instant access to the PDF manual and all bonuses on your phone, tablet, or PC immediately after purchase.'
  }, {
    q: "What if I don't see results?",
    a: 'You are covered by our 60-Day "More Tail Wags" Guarantee. If you aren\'t 100% happy, we refund your money and you keep the book for free.'
  }];
  return <section className="py-20 md:py-28 px-6 bg-deep" data-id="element-27">
      <div className="max-w-3xl mx-auto" data-id="element-28">
        <FadeIn className="text-center mb-12" data-id="element-29">
          <h3 className="uppercase tracking-[0.3em] text-amber text-sm font-semibold mb-4" data-id="element-30">
            FAQ
          </h3>
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-31">
            Common Questions
          </h2>
        </FadeIn>

        <div className="mt-8" data-id="element-32">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-33" />)}
        </div>
      </div>
    </section>;
}